import firebase from 'firebase'
import Fab from '@material-ui/core/Fab'
import Box from '@material-ui/core/Box'
import Link from '@material-ui/core/Link'
import Grid from '@material-ui/core/Grid'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router'
import { FcGoogle } from 'react-icons/fc'
import { AuthStyles } from './auth.module'
import { useEffect, useState } from 'react'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import { Typography } from '@material-ui/core'
import Tooltip from '@material-ui/core/Tooltip'/* 
import { FaFacebookSquare } from 'react-icons/fa' */
import Copyright from '../../components/Copyright'
import Container from '@material-ui/core/Container'
import { makeStyles } from '@material-ui/core/styles'
import DividerText from '../../components/DividerText'
import { useSession } from '../../context/SessionContext'
import RegisterSuccessDialog from './RegisterSuccessDialog'
import { JustiInputText } from '../../components/InputText'
import Alert, { ActionsOptType } from '../../components/Alert'
import { Checkbox, FormControl, FormControlLabel, useTheme } from '@material-ui/core'

/**
 * define styles for the component
*/
const useStyles = makeStyles((theme) => ({
  fab: {
    margin: theme.spacing(0.3),
    background: "#ec9405"
  },
  absolute: {
    position: 'absolute',
    bottom: theme.spacing(0.3),
    right: theme.spacing(0.5),
  },
}))

// Define IFormRegister interface
interface IFormRegister {
  username: string
  password: string
  passwordConfirm: string
}

/**
 * Custom `Register` component declaration.
 * This component is used to Register user and functionalities
 * @return Register
*/
const Register = (): JSX.Element => {
/*   const [validator, setValidator] = useState(false) */
  const classes = AuthStyles()
  const history = useHistory()
  const style = useStyles()
  const theme = useTheme()
  const [openRegisterDialog, setOpenRegisterDialog] = useState(false)
  const { register, message, autenticated, token, loginGoogle, /* loginFacebook, */ registervalidator } = useSession()
  const { control, handleSubmit, errors } = useForm<IFormRegister>()
  const [checked, setChecked] = useState(true)
  const [username] = useState('')
  const [alertOptions, setAlertOptions] = useState<ActionsOptType>({
    message: null,
    type: null,
    open: false,
  })

  /**
   * This method is used to create user
   * @param {string} username
   * @param {string} password
   * @Return {void}
  */
  const createUser = (email: string, password:string)=> {
    firebase.auth().createUserWithEmailAndPassword(email, password)
    .then((userCredential) => {
      const user = userCredential.user;
      if(user)
      {
        firebase.auth().onAuthStateChanged((user) => {
          const uid = user?.uid.valueOf();
          const username = email
          if (register) 
          {
            register({ username, uid, email })
            if(registervalidator)
            {
              registervalidator(username).then((result) => {
                if(result !== true)
                {
                 /*  pruebaValidator() */
                  openDialog()
                  user?.sendEmailVerification()
                }
              })
            }
          }
        })
      } else{
        setAlertOptions({
          message: "Por favor ingrese información válida para continuar con el registro.",
          open: true,
          type: 'error',
        })
      }
    })
    .catch((error) => {
      const errorCode = error.code;
      setAlertOptions({
        message: errorCode,
        open: true,
        type: 'error',
      })
      const errorMessage = error.message;
      setAlertOptions({
        message: errorMessage,
        open: true,
        type: 'error',
      })
    });
  }

  /* const pruebaValidator = () => {
    setValidator(true)
  } */

  /**
   * This method is used to open openRegisterDialog
   * @Return {void}
  */
  const openDialog = () => {
    setOpenRegisterDialog(true)
  }

  /**
   * This method is used to validate passwords
   * @param {string} username
   * @param {string} password
   * @param {string} passwordConfirm
   * @Return {void}
  */
  const onSubmit = ({ username, password, passwordConfirm }: IFormRegister) => {
    if (password !== passwordConfirm) {
      setAlertOptions({
        message: 'Las contraseñas deben ser iguales',
        open: true,
        type: 'error',
      })
      return
    }
    createUser(username, password)
  }

  /**
   * This method is used to redirect the app
   * @Return {void}
  */
  useEffect(() => {
    if (autenticated || token) {
       history.push('/docengine')
    }
    if (message) {
      setAlertOptions({ message: message.text, open: true, type: message.type })
    }
  }, [message,  history, autenticated ])

  return (
    <Container
      component="main"
      maxWidth="xs"
      style={{ height: '100vh', display: 'flex' }}
    >
    <RegisterSuccessDialog
      open={openRegisterDialog}
      setOpen={setOpenRegisterDialog}
    />
      <Alert alertOptions={alertOptions} setAlertOptions={setAlertOptions} />

      <div className={classes.paper}>
        <Avatar
          alt="JustiExpress"
          src="/logo.png"
          className={classes.JustiLogo}
        />

        <Typography
          component="p"
          variant="body1"
          align="center"
          color="textPrimary"
          gutterBottom
          style={{ fontSize: '1rem', fontWeight: 'normal', marginBottom: '10px' }}
        >
          1. Regístrate en nuestra plataforma
        </Typography>
        <div>
          <Tooltip title={<h3 style={{ color: "white" }}>Registrarse</h3>}>
            <Fab color="primary" className={style.fab} style={{width: '45px', height: '45px'}}>
              1
            </Fab>
          </Tooltip>
          <Tooltip title={<h3 style={{ color: "white"}}>Elije el tipo de documento</h3>}>
            <span>
              <Button disabled style={{marginRight: '10vh', marginLeft:'10vh' }}>2</Button>
            </span>
          </Tooltip>
          <Tooltip title={<h3 style={{ color: "white"}}>Responde a las preguntas y descarga el documento</h3>}>
            <span>
              <Button disabled>3</Button>
            </span>
          </Tooltip>
        </div>

        <form
          className={classes.form}
          noValidate
          onSubmit={handleSubmit(onSubmit)}
        >
          <JustiInputText
            name={'username'}
            copy={'Usuario (Correo electrónico)'}
            regex={/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i}
            errorMessage={'Correo inválido'}
            defaultValue={username}
            errors={errors}
            control={control}
            autoFocus={true}
          />
          <JustiInputText
            name={'password'}
            copy={'Contraseña'}
            // regex={/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{6,}$/}
            errorMessage={
              'La contraseña debe tener una mayúscula, una mínuscula, un número y más de 6 caracteres'
            }
            type={'password'}
            errors={errors}
            control={control}
          />

          <JustiInputText
            name={'passwordConfirm'}
            copy={'Confirmar contraseña'}
            // regex={/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{6,}$/}
            errorMessage={
              'La contraseña debe tener una mayúscula, una mínuscula, un número y más de 6 caracteres'
            }
            type={'password'}
            errors={errors}
            control={control}
          />

          <Grid
            item
            xs={12}
            style={{ marginTop: '2.5vh', marginBottom: '1.5vh' }}
          >
            <DividerText text={'o regístrate con'} spacing={3} />
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <FcGoogle
              size={'2em'} style={{ marginTop: '0.5vh'}}
              onClick={async () => {
                try {
                  const provider = new firebase.auth.GoogleAuthProvider()
                  const result = await firebase.auth().signInWithPopup(provider)
                  if (result) {
                    const email = result.user?.email
                    if(email && registervalidator)
                    {
                      await registervalidator(email).then((result) => {
                        if(result !== true)
                        {
                          openDialog()
                        }
                      })
                    }
                    if (loginGoogle) await loginGoogle(result.user)
                  }
                } catch {
                  console.error('¡UPPPS! SOMETHING WRONG IN PROCESS LOGIN')
                }
              }}
            />
            {/* <FaFacebookSquare
              style={{ marginLeft: '1.0vh'}}
              size={'2em'}
              onClick={async () => {
                try {
                  const provider = new firebase.auth.FacebookAuthProvider()
                  const result = await firebase.auth().signInWithPopup(provider)
                  if (result) {
                    if (loginFacebook) loginFacebook(result.user)
                  }
                } catch {
                  console.error('¡UPPPS! SOMETHING WRONG IN PROCESS LOGIN')
                }
              }}
            /> */}
          </Grid>

          <FormControl component="fieldset">
            <FormControlLabel
              control={
                <Checkbox
                  checked={checked}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setChecked(event.target.checked)
                  }}
                  color={'primary'}
                  name="gilad"
                />
              }
              label={
                <Typography
                  style={{
                    whiteSpace: 'pre-line',
                    marginTop: '1.5vh',
                    marginBottom: '2vh',
                  }}
                  variant="body2"
                  color="textSecondary"
                  align="justify"
                >
                  {'Acepto los '}
                  <Link
                    variant="body2"
                    href="https://justiexpressdev.github.io/landing/terminos-y-condiciones.html"
                    style={{ color: theme.palette.secondary.dark }}
                  >
                    {'Términos y Condiciones '}
                  </Link>
                  y
                  <Link
                    variant="body2"
                    href="https://justiexpressdev.github.io/landing/aviso-de-privacidad.html"
                    style={{ color: theme.palette.secondary.dark }}
                  >
                    {' Política de Privacidad'}
                  </Link>
                </Typography>
              }
            />
          </FormControl>

          <Button
            type="submit"
            disabled={Object.keys(errors).length > 0 || !checked}
            fullWidth
            variant="contained"
            className={classes.submitRegister}
          >
            REGISTRARSE
          </Button>
        </form>
        <Grid container justifyContent="flex-end">
          <Grid item>
            <Link className={classes.link} href="/login" variant="body2">
              ¿Ya tienes una cuenta? Ingresa
            </Link>
          </Grid>
        </Grid>

        <Box mt={8} style={{ marginTop: '2.5vh',}}>
          <Copyright />
        </Box>
      </div>
    </Container>
  )
}

export default Register